<template>

    <div>
        <form class="needs-validation" novalidate>
            <!-- ***** start custom content ***** -->
            <h1>{{$t('voter_list')}}</h1>

            <h2 class="mb-4">{{$t('confirmation')}}</h2>
            <h3 class="mb-3">{{$t('personal_detail')}}</h3>
            <p class="mb-2"><span class="font-weight-bold">{{$t('name')}}{{ $t('colon')}}</span> {{ full_name }} </p>
            <p class="mb-2"><span class="font-weight-bold">{{$t('date_of_birth')}}{{ $t('colon')}}</span> {{ birth_date }} </p>
            <p class="mb-2"><span class="font-weight-bold">{{$t('Address')}}{{ $t('colon')}}</span> {{ home_address }} </p>
            <p v-if="previous_address" class="mb-2"><span class="font-weight-bold">{{$t('previous_address')}}{{ $t('colon')}}</span> {{ previous_address }} </p>
            <a @click="go_to_step('Step2')" class="btn btn-sm btn-outline-secondary icon-link mt-2 mb-4"><i class="far fa-edit" aria-hidden="true"></i>{{$t('edit_personal_information')}}</a>

            <h3 class="mb-3">{{$t('contact_detail')}}</h3>
            <p class="mb-2"><span class="font-weight-bold">{{$t('email')}}{{ $t('colon')}}</span> {{ email }} </p>
            <p class="mb-2"><span class="font-weight-bold">{{$t('phone_number')}}{{ $t('colon')}}</span> {{ phone }} </p>
            <a @click="go_to_step('Step3')" class="btn btn-sm btn-outline-secondary icon-link mt-2 mb-4"><i class="far fa-edit" aria-hidden="true"></i>{{$t('edit_contact_information')}}</a>

            <div class="row no-gutters">
                <div class="custom-control custom-checkbox mb-5">
                    <input type="checkbox" class="custom-control-input" required id="confirmCheck" v-model="confirmed">
                    <label class="custom-control-label" for="confirmCheck" v-html="$t('i_confirm')"></label>
                </div>
            </div>
            <div class="row no-gutters">
                <vue-recaptcha ref="recaptcha" @verify="onVerify" :sitekey="$CAPTCHA_KEY" :loadRecaptchaScript="true" :language="language"></vue-recaptcha>
                <div class="invalid-feedback" v-if="is_robot">
                    {{$t('Please verify that you are not a robot.')}}
                </div>
            </div>
            <div v-if="error_posting">
                <p>
                    {{$t('error_posting')}}
                </p>
            </div>
            <div class="row no-gutters" v-if="!seb_registry_closed">
                <div class="col"><button class="btn btn-outline-secondary mt-4 float-right" @click="prev_step">{{$t('previous')}}</button></div>
                <div class="col-auto"><button :disabled="confirm_button" class="btn btn-secondary mt-4 ml-3" @click="next_step">{{$t(next_button_text)}}</button></div>
            </div>
            <div class="row no-gutters" v-if="seb_registry_closed">
                <p>{{$t('comment_15')}}</p>
            </div>
                <!-- ***** end custom content ***** -->
        </form>
    </div>
</template>
<style>
    a:hover{
        cursor:pointer;
    }
</style>
<script>
    import $ from "jquery";
    import axios from 'axios';
    import VueRecaptcha from 'vue-recaptcha'
    import axiosRetry from 'axios-retry';

    export default {
        components: { VueRecaptcha },

        data() {
            return {
                voter: {},
                errors: [],
                contact_info: [],
                personal_info: [],
                url: this.$APP_API_URL,
                error_mail_url: this.$ERROR_MAIL_API_URL,
                is_robot: true,
                confirmed: false,
                response: {},
                registration_id: null,
                language: "en",
                confirmButton: "confirm",
                waitButton: 'Please wait....',
                button_click: false,
                error_posting: false,
                email_error_sent: false,
                seb_registry_closed: false,
            }
        },

        computed: {
            birth_date: function () {
                let result = "";

                if (this.personal_info.length > 0);
                    result = this.personal_info[0].birth_year + '-' + ('0' + this.personal_info[0].birth_month).slice(-2) + '-' + ('0' + this.personal_info[0].birth_day).slice(-2);

                return result;
            },
            home_address: function () {
                let result = "";
                if (this.personal_info.length > 0);
                    result = (this.personal_info[0].street_number + ' ' + this.personal_info[0].street_name + ' ' + ((this.personal_info[0].street_type) ? this.personal_info[0].street_type : ''));

                return result;

            },
            full_name: function () {
                let result = "";
                if (this.personal_info.length > 0) {
                    result = this.personal_info[0].first_name + " " + this.personal_info[0].last_name;
                }

                return result;
            },
            email: function () {
                let result = "";
                if (this.contact_info.length > 0)
                    result = this.contact_info[0].email;

                return result;
            },
            phone: function () {
                let result = "";
                if (this.contact_info.length > 0)
                    result = this.contact_info[0].phone;

                return result;
            },
             previous_address: function () {
                let result = null;
                if (this.personal_info.length > 0) {
                    if (this.personal_info[0].recently_moved === 'Yes') {
                        result = (this.personal_info[0].prev_street_number + ' ' + this.personal_info[0].prev_street_name + ' ' + ((this.personal_info[0].prev_street_type) ? this.personal_info[0].prev_street_type : ''));
                    }
                }
                return result;
            },

            disabled_submit() {
                return !(!this.is_robot && this.confirmed);
            },
            next_button_text() {
                var result = (this.button_click ? this.waitButton : this.confirmButton);

                return result;
            },
            confirm_button() {
                return this.button_click;
            },
        },

        created: async function () {
            //this.$store.dispatch("GET_VOTER");

            //this.voter = this.$store.getters.VOTER;
            this.personal_info = this.$store.getters.PERSONAL_INFO;
            this.contact_info = this.$store.getters.CONTACT_INFO;
            this.language = process.env.VUE_APP_I18N_LOCALE;
            let url = this.url.replace("ElectionApplication.asp", "SEBDateValidation.ashx");

            await axios.get(url).then((result) => {
                this.seb_registry_closed = eval(result.data.toLowerCase());
            })
        },

        methods: {
            onVerify(response) {
                if (response) {
                    this.is_robot = false;
                }
            },

            async next_step() {
                var address = "home address: " + this.home_address;
                var firstName = "";
                var lastName = "";
                var prevStreetName = "";
                var prevStreetNumber = "";
                var prevStreetType = "";
                if (this.personal_info.length > 0) {
                    firstName = this.personal_info[0].first_name;
                    lastName = this.personal_info[0].last_name;
                    prevStreetName = this.personal_info[0].prev_street_name;
                    prevStreetNumber = this.personal_info[0].prev_street_number;
                    prevStreetType = this.personal_info[0].prev_street_type;
                }
                var priority = this.$route.params.page_type.toUpperCase();

                // Fetch all the forms we want to apply custom Bootstrap validation styles to
                var forms = document.getElementsByClassName('needs-validation');
                // Loop over them and prevent submission
                var validation = false;

                Array.prototype.filter.call(forms, function (form) {
                    validation = form.checkValidity();

                    if (form.checkValidity() === false) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    form.classList.add('was-validated');

                    $(".invalid-feedback").removeClass("invalid-feedback").addClass("invalid");
                });
                
                if (this.is_robot) {
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                }

                if (validation === true) {
                    var data = {
                        firstName: firstName,
                        lastName: lastName,
                        birthDate: this.birth_date,
                        email: this.email,
                        phone: this.phone,
                        address: address,
                        prevStreetNumber: prevStreetNumber,
                        prevStreetName: prevStreetName,
                        prevStreetType: prevStreetType,
                        priority: priority,
                        Action: 'register',
                    };

                    let self = this;

                    var params = new URLSearchParams();
                    for (var i in data) {
                        if (Object.prototype.hasOwnProperty.call(data, i)) {
                            params.append(i, data[i]);
                        }
                    }

                    this.button_click = true;

                    axiosRetry(axios, {
                        retries: 5,
                        shouldResetTimeout: true,
                        retryCondition: () => true,
                        retryDelay: (retryCount) => {
                            console.log(`retry attempt: ${retryCount}`);
                            return retryCount * 2000; // time interval between retries
                        }
                    });

                    await axios.post(this.url, params)
                        .then(function (response) {
                            let page = "Step5";
                            if (self.$route.params.page_type === "seb") {
                                page = "SealedEnvelopeBallotStep1";
                            }

                            self.$router.push({ name: page, params: { page_type: self.$route.params.page_type, voter_id: self.$route.params.voter_id, registration_id: response.data.registrationId } });
                        })
                        .catch(function (error) {
                            console.log(error);
                            self.button_click = false;
                            if (!self.email_error_sent) {
                                var formData = new URLSearchParams();
                                formData.append("t", "0");
                                formData.append("e", error.response.status + " " + error.response.statusText);

                                axios.post(self.error_mail_url, formData);

                                self.email_error_sent = true;
                            }

                            self.error_posting = true;
                        })
                }
            },

            go_to_step: function (step) {
                this.$router.push({ name: step, params: { page_type: this.$route.params.page_type, voter_id: this.$route.params.voter_id } });
            },
            prev_step: function () {
                this.$router.push({ name: "Step3", params: { page_type: this.$route.params.page_type, voter_id: this.$route.params.voter_id } });
            }
        }
    }
</script>
